import React from "react";
import { Route, Switch } from "polyrouter";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import { LicensingTable } from "./List/LicensingTable";
import { LicenseDetails } from "./Details/LicenseDetails";
import { useLicenseCountQuery } from "generated/graphql";
import { LoadingIndicator, NoResultsIndicatorAnimation } from "elements";
import { useLicenseTypeFromRoute } from "./hooks";
import { useTenantId } from "polyrouter/SelectedTenantProvider";

export const LicenseKeysRouter: React.FC = () => {
  const { t } = useTranslation();
  const tenantId = useTenantId();
  const type = useLicenseTypeFromRoute();
  const { data, fetching } = useLicenseCountQuery({
    variables: { tenantId, type, canceled: false }
  });
  const { Content } = Layout;

  return (
    <Switch nest>
      <Route path="/details/:licenseKey">
        <LicenseDetails />
      </Route>
      <Route path="">
        <Content className="licensing-overview">
          {!data?.licenseCount ? (
            fetching ? (
              <LoadingIndicator />
            ) : (
              <NoResultsIndicatorAnimation title={t("NO_LICENSES_FOUND")} />
            )
          ) : (
            <>
              <div className="table-heading">
                <span className="metric">{data?.licenseCount}</span>
                <span className="title ml-5">{t("LICENSE_KEYS")}</span>
              </div>
              <LicensingTable />
            </>
          )}
        </Content>
      </Route>
    </Switch>
  );
};
